import { render, staticRenderFns } from "./ListaReclamacionesDetalle.vue?vue&type=template&id=6ee39222&scoped=true&"
import script from "./ListaReclamacionesDetalle.vue?vue&type=script&lang=js&"
export * from "./ListaReclamacionesDetalle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee39222",
  null
  
)

export default component.exports